<template>
  <v-chip class="ma-2" :color="levelColor(level)" text-color="white" small>
    Lv.{{ level }}
  </v-chip>
</template>

<script>
import getRendColor from "@/tools/rendomColor";
export default {
  props: {
    level: {
      type: Number,
      default() {
        return 1;
      }
    }
  },
  methods: {
    levelColor(n) {
      let colorList = ["grey", "green", "blue", "orange", "red"];
      return getRendColor(colorList, n);
    }
  }
};
</script>

<style></style>
